(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Purchase', Purchase);

    Purchase.$inject = ['$resource', 'DateUtils'];

    function Purchase ($resource, DateUtils) {
        var resourceUrl =  'api/purchases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        data.desirableExecutionDate = DateUtils.convertLocalDateFromServer(data.desirableExecutionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.issueDate = DateUtils.convertLocalDateToServer(data.issueDate);
                    data.desirableExecutionDate = DateUtils.convertLocalDateToServer(data.desirableExecutionDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.issueDate = DateUtils.convertLocalDateToServer(data.issueDate);
                    data.desirableExecutionDate = DateUtils.convertLocalDateToServer(data.desirableExecutionDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
